import { Config } from '@/config/types';
import { DeepPartial } from '@/config/deepMerge';

const env = import.meta.env.VITE_ENV || 'DEV';
const awsAccountId = env === 'DEV' ? '129513515892' : '047050865332';

export const brandOverrides: DeepPartial<Config> = {
  app: {
    useGoogleSignIn: true,
    useAppleSignIn: true,
    companyDetails: {
      name: 'Catalina Software',
      url: 'https://catalina-software.co.uk/',
      ownerId: 'CSL',
      telephoneNumber: '01366 386611',
      supportToEmail: 'support@catalina-software.co.uk',
      termsUrl: 'https://catalina-software.co.uk/privacy-policy/',
    },
    webxEmbed: {
      useSecondaryHeaderColour: import.meta.env.MODE === 'development',
    },
  },
  services: {
    cloudWatch: {
      logGroupName: `/freedom/gox-${env}/app/v1`,
    },
    sns: {
      androidPlatformArn: `arn:aws:sns:eu-west-2:${awsAccountId}:app/GCM/Freedom-GoX-Android-${env}`,
      iOsPlatformArn: `arn:aws:sns:eu-west-2:${awsAccountId}:app/APNS${env === 'DEV' ? '_SANDBOX' : ''}/Freedom-GoX-iOS-${env}`,
    },
    integraLink: {
      lambdaArn: `arn:aws:lambda:eu-west-2:${awsAccountId}:function:GoXIntegraLink-${env}`,
    },
  },
};
